@if (!loading) {
  <app-user-header [user]="user" />
  <app-user-form [user]="user" [mode]="formModes.update" />
} @else {
  <mat-spinner />
}
